import {APIURLREINGENIERIALEGALES} from "../../const/backend"
import apiClient from "../../utils/apiClient";

class ApiServiceAdapter  {
  async fetchEstadosJuicios() {
    const url=APIURLREINGENIERIALEGALES + "/GetJuiciosEstados"
    const response = apiClient.get(url, {useReing: true})
    const data = await response
    return data;
  }
}

export default ApiServiceAdapter;